import axios from 'axios';

export async function obtenerAutorizacionIndividual(hash) {
  const response = await axios.get(`/autorizaciones-tarjeta/${encodeURIComponent(hash)}`);
  return response.data.data;
}

export async function completarAutorizacionIndividual(hash, formulario) {
  // Los importes y el destinatario se conservan en Servicios, según lo preparado en Gestión.
  const response = await axios.post(`/autorizaciones-tarjeta/${encodeURIComponent(hash)}`, {
    autorizacion_numerotarjeta: formulario.numeroTarjeta,
    autorizacion_fechacaducidad: formulario.fechaCaducidad,
    autorizacion_titular: formulario.titularTarjeta.trim(),
    autorizacion_fechadeposito: formulario.fechaDeposito,
  });
  return response.data;
}
